import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FORM_FIELD_TYPES } from '..';
import Button from '../../Button';
import FormCheckbox from '../FormCheckbox';
import FormDropdown from '../FormDropdown/FormDropdown.component';
import FormDynamicField from '../FormDynamicField';
import FormInput from '../FormInput';
import FormRadioGroup from '../FormRadioGroup';
import FormRelatedFields from '../FormRelatedFields';
import FormTextArea from '../FormTextArea';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormField(_ref) {
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors,
    getValues = _ref.getValues,
    handleSetValue = _ref.handleSetValue,
    handleResetField = _ref.handleResetField,
    handleSetError = _ref.handleSetError,
    handleClearErrors = _ref.handleClearErrors,
    handleTriggerValidation = _ref.handleTriggerValidation,
    reset = _ref.reset,
    btnProps = _ref.btnProps,
    onChangeAction = _ref.onChangeAction;
  var type = formField.type;
  if (formField.hidden === true) {
    return null;
  }
  switch (type) {
    case FORM_FIELD_TYPES.BUTTON:
    case FORM_FIELD_TYPES.SUBMIT:
      return _jsx(Button, _objectSpread(_objectSpread({
        "data-testid": formField.testid
      }, btnProps), {}, {
        children: btnProps === null || btnProps === void 0 ? void 0 : btnProps.label
      }));
    case FORM_FIELD_TYPES.INPUT_TEXT:
    case FORM_FIELD_TYPES.INPUT_EMAIL:
    case FORM_FIELD_TYPES.INPUT_PASSWORD:
      return _jsx(FormInput, {
        control: control,
        formField: formField,
        errors: errors
      });
    case FORM_FIELD_TYPES.RADIO_GROUP:
      {
        return _jsxs(_Fragment, {
          children: [_jsx(FormRadioGroup, {
            control: control,
            formField: formField,
            errors: errors,
            handleSetValue: handleSetValue,
            onChangeAction: onChangeAction
          }), !!formField.relatedFields && _jsx(FormRelatedFields, {
            fieldName: formField.name,
            relatedFields: formField.relatedFields,
            control: control,
            errors: errors,
            handleSetValue: handleSetValue,
            handleResetField: handleResetField,
            getValues: getValues,
            reset: reset
          })]
        });
      }
    case FORM_FIELD_TYPES.CHECKBOX:
      {
        return _jsxs(_Fragment, {
          children: [_jsx(FormCheckbox, {
            control: control,
            formField: formField,
            errors: errors
          }), !!formField.relatedFields && _jsx(FormRelatedFields, {
            fieldName: formField.name,
            relatedFields: formField.relatedFields,
            control: control,
            errors: errors,
            handleSetValue: handleSetValue,
            handleResetField: handleResetField,
            getValues: getValues,
            reset: reset
          })]
        });
      }
    case FORM_FIELD_TYPES.NON_FIELD_CONTENT:
      return _jsx(_Fragment, {
        children: formField.content
      });
    case FORM_FIELD_TYPES.DROPDOWN:
      return _jsx(FormDropdown, {
        formField: formField,
        control: control,
        errors: errors,
        handleSetValue: handleSetValue,
        onChangeAction: onChangeAction
      });
    case FORM_FIELD_TYPES.DYNAMIC_FIELD:
      return _jsxs(_Fragment, {
        children: [_jsx(FormDynamicField, {
          control: control,
          formField: formField,
          errors: errors,
          handleSetValue: handleSetValue,
          handleResetField: handleResetField,
          handleSetError: handleSetError,
          handleClearErrors: handleClearErrors,
          handleTriggerValidation: handleTriggerValidation,
          getValues: getValues,
          reset: reset
        }), !!formField.relatedFields && _jsx(FormRelatedFields, {
          fieldName: formField.name,
          relatedFields: formField.relatedFields,
          control: control,
          errors: errors,
          handleSetValue: handleSetValue,
          handleResetField: handleResetField,
          handleSetError: handleSetError,
          handleClearErrors: handleClearErrors,
          getValues: getValues,
          reset: reset
        })]
      });
    case FORM_FIELD_TYPES.TEXTAREA:
      return _jsx(FormTextArea, {
        control: control,
        formField: formField,
        errors: errors
      });
    default:
      return null;
  }
}